import useMessageThreads from './useMessageThreads';

export default function useCachedMessageThreads() {
  const result = useMessageThreads({ fetchPolicy: 'cache-only' });

  return result;
}
